// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"ee18f0f5","211":"50af8854"}[chunkId] + ".chunk.css";
};